import { useEffect, useState } from "react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import VerifiedName from "../components/VerifiedName";
import { Trophy } from "lucide-react";

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/leaderboard").then(({ data }) => setRows(data)); }, []);
  return (
    <div className="min-h-screen bg-[#030705] text-white">
      <Navbar />
      <section className="max-w-4xl mx-auto px-6 md:px-10 pt-20 pb-20">
        <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4 flex items-center gap-2"><Trophy className="w-3.5 h-3.5" /> This week</div>
        <h1 className="font-display text-5xl md:text-7xl font-black tracking-tighter mb-12">Top spinners.</h1>
        <div className="rounded-2xl border border-white/5 bg-[#0A130E] overflow-hidden">
          {rows.length === 0 && <div className="p-10 text-center text-white/40">No players yet — be the first.</div>}
          {rows.map((u, i) => (
            <div key={u.username + i} data-testid={`leaderboard-row-${i}`}
                 className={`flex items-center justify-between px-6 py-4 border-b border-white/5 last:border-0 ${i < 3 ? "bg-gradient-to-r from-[#D4AF37]/5 to-transparent" : ""}`}>
              <div className="flex items-center gap-5">
                <span className={`font-display text-3xl font-black w-12 ${i < 3 ? "gold-text" : "text-white/30"}`}>#{i + 1}</span>
                <VerifiedName user={u} name={u.username} className="min-w-0 text-lg font-medium" />
              </div>
              <span className="text-right">
                <span className="block font-medium tabular-nums text-white/80">{leaderMoney(u)}</span>
                <span className="block text-xs uppercase tracking-[0.16em] text-white/40">weekly loaded</span>
                {u.reward && (
                  <span className="mt-1 inline-flex rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10 px-2 py-0.5 text-[11px] font-black text-[#F8E08E]">
                    {u.reward.label}
                  </span>
                )}
              </span>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}

function leaderMoney(row) {
  const coins = Number(row?.total_load_coins ?? row?.coins ?? 0);
  return `$${(coins / 1000).toFixed(2)}`;
}
